// Amazon Associates tag — automatically appended to Amazon buy links.
const AMAZON_TAG = 'mirnalini-21';

// If the URL is an Amazon link and has no tag yet, append the associate tag.
// Non-Amazon URLs and links that already carry a tag are returned unchanged.
export const withAffiliateTag = (url) => {
  if (!url) return url;
  try {
    const u = new URL(url);
    if (/(^|\.)amazon\./i.test(u.hostname)) {
      if (!u.searchParams.get('tag')) {
        u.searchParams.set('tag', AMAZON_TAG);
      }
    }
    return u.toString();
  } catch {
    return url;
  }
};
